module.exports = __webpack_public_path__ + "img/titulo-estudio.2bc70152.png";